(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mischief-cart-drawer"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('mischief-cart');
  if (!dialog || window.MischiefCart) return;
  const config = dialog.dataset;
  let busy = false;
  let uncertain = false;
  let pending = null;
  let timer;
  let lastFocus;
  const page = () => document.querySelector('[data-mc-page]');
  const sectionIds = () => [config.sectionId, page()?.dataset.sectionId].filter(Boolean);
  const roots = () => [dialog, page()].filter(Boolean);
  const message = (text) => {
    document.querySelectorAll('[data-mc-status],[data-mc-page-status]').forEach(el => { el.textContent = text; });
  };
  const lock = () => {
    roots().forEach(root => {
      root.setAttribute('aria-busy', String(busy));
      root.querySelectorAll('[data-mc-add],[data-mc-quantity],.mc-checkout,[data-mc-input]').forEach(el => {
        if ('disabled' in el) el.disabled = busy || uncertain;
        el.setAttribute('aria-disabled', String(busy || uncertain));
      });
      root.querySelectorAll('.mc-checkout').forEach(el => { el.disabled = busy || uncertain || !!pending; });
    });
    dialog.querySelector('[data-mc-recover]').hidden = !uncertain;
  };
  const open = () => {
    if (!dialog.open) {
      lastFocus = document.activeElement;
      dialog.showModal();
    }
  };
  const close = () => {
    dialog.close();
    if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});
  };
  const render = (sections) => {
    const html = sections?.[config.sectionId];
    if (!html) throw new Error(config.error);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-mc-content]');
    if (!fresh) throw new Error(config.error);
    const oldContentScroll = dialog.querySelector('[data-mc-content]').scrollTop;
    const oldScroll = dialog.querySelector('.mc-scroll')?.scrollTop || 0;
    dialog.querySelector('[data-mc-content]').replaceWith(fresh);
    fresh.scrollTop = oldContentScroll;
    const scroller = dialog.querySelector('.mc-scroll');
    if (scroller) scroller.scrollTop = oldScroll;
    const cartPage = page();
    if (cartPage) {
      const pageHtml = sections[cartPage.dataset.sectionId];
      if (!pageHtml) throw new Error(config.error);
      const freshPage = new DOMParser().parseFromString(pageHtml,'text/html').querySelector('[data-mc-page]');
      if (!freshPage) throw new Error(config.error);
      cartPage.replaceWith(freshPage);
    }
    const count = Number(fresh.dataset.count);
    const countBadge = dialog.querySelector('[data-mc-count]');
    if (countBadge) countBadge.textContent = String(count).padStart(2, '0');
    document.querySelectorAll('.header__actions a').forEach(link => {
      if (new URL(link.href,location.href).pathname !== config.cartUrl) return;
      let badge = link.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.append(badge); }
        badge.textContent = String(count);
      } else badge?.remove();
      link.setAttribute('aria-label', dialog.querySelector('h2').textContent + ' (' + count + ')');
    });
  };
  const read = async () => {
    const url = new URL(config.cartUrl,location.origin);
    url.searchParams.set('sections',sectionIds().join(','));
    const response = await fetch(url.toString(), {cache:'no-store'});
    if (!response.ok) throw new Error(config.error);
    render(await response.json());
  };
  const refresh = async () => {
    if (busy) return;
    clearTimeout(timer);
    pending = null;
    busy = true; lock(); message(config.loading);
    try { await read(); uncertain = false; message(''); }
    catch { uncertain = true; message(config.error); }
    finally { busy = false; lock(); }
  };
  const mutate = async (url, payload, source, success, show) => {
    if (busy || uncertain) return;
    clearTimeout(timer); pending = null;
    busy = true;
    const sourceDisabled = source?.disabled;
    const active = document.activeElement;
    const focusKey = active?.dataset?.mcKey;
    const focusAction = active?.dataset?.mcAction;
    if (source) source.disabled = true;
    if (show) open();
    lock(); message(config.loading);
    let rejected = false;
    try {
      const ids = sectionIds();
      if (payload instanceof FormData) {
        payload.set('sections',ids.join(',')); payload.set('sections_url',config.cartUrl);
      } else payload = JSON.stringify({...payload, sections:ids, sections_url:config.cartUrl});
      const headers = {Accept:'application/json'};
      if (typeof payload === 'string') headers['Content-Type'] = 'application/json';
      const response = await fetch(url,{method:'POST',headers,body:payload});
      const data = await response.json();
      if (!response.ok) {
        rejected = true;
        throw new Error(typeof data.description === 'string' ? data.description : config.error);
      }
      try { render(data.sections); } catch { await read(); }
      message(success);
      if (focusKey) {
        const scope = dialog.open ? dialog : page();
        const candidates = Array.from(scope?.querySelectorAll('[data-mc-key]') || []);
        const target = candidates.find(el => el.dataset.mcKey === focusKey && el.dataset.mcAction === focusAction)
          || candidates.find(el => el.dataset.mcKey === focusKey);
        (target || dialog.querySelector('#mc-title')).focus({preventScroll:true});
      } else if (dialog.open) dialog.querySelector('#mc-title').focus({preventScroll:true});
    } catch (error) {
      uncertain = true;
      if (rejected) {
        try { await read(); uncertain = false; } catch { uncertain = true; }
      }
      message(error.message || config.error);
      if (!dialog.open) open();
    } finally {
      busy = false;
      if (source?.isConnected) source.disabled = sourceDisabled;
      lock();
    }
  };
  const addProduct = (form, source) => {
    if (!form.reportValidity()) return;
    mutate(config.addUrl,new FormData(form),source,config.added,true);
  };
  const change = (key,quantity) => {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    mutate(config.changeUrl,{id:key,quantity},null,config.updated,false);
  };
  window.MischiefCart = {addProduct};
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-mc-close]')) { close(); return; }
    if (target.matches('[data-mc-refresh]')) { refresh(); return; }
    if (target.matches('[data-mc-add]')) {
      event.preventDefault();
      mutate(config.addUrl,{items:[{id:Number(target.dataset.mcAdd),quantity:1}]},target,config.added,false);
      return;
    }
    if (target.matches('[data-mc-quantity]')) {
      event.preventDefault();
      change(target.dataset.mcKey,Number(target.dataset.mcQuantity));
      return;
    }
    if (target.tagName === 'A' && !target.hasAttribute('data-mc-view') && !target.closest('.mc-recover') && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      const url = new URL(target.href,location.href);
      if (url.origin === location.origin && url.pathname === config.cartUrl && !url.search) {
        event.preventDefault(); open(); refresh();
      }
    }
  });
  dialog.addEventListener('click',event => { if(event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) close(); } });
  dialog.addEventListener('cancel',event => { event.preventDefault(); close(); });
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action,location.href).pathname;
    if (action === config.addUrl.replace(/\.js$/,'')) {
      event.preventDefault(); addProduct(form,event.submitter); return;
    }
    if (form.closest('#mischief-cart,[data-mc-page]') && (busy || uncertain || pending)) {
      event.preventDefault();
      if (pending && !busy && !uncertain) { const value=pending; change(value.key,value.quantity); }
    }
  });
  document.addEventListener('input',event => {
    if (!event.target.matches('[data-mc-input]')) return;
    const input=event.target;
    const quantity=Number(input.value);
    pending={key:input.dataset.mcKey,quantity};
    roots().forEach(root=>root.querySelectorAll('.mc-checkout').forEach(button=>{button.disabled=true;}));
    clearTimeout(timer);
    if(input.value !== '' && Number.isInteger(quantity) && quantity>=0) timer=setTimeout(()=>change(input.dataset.mcKey,quantity),650);
  });
  document.addEventListener('change',event => {
    if (!event.target.matches('[data-mc-input]')) return;
    clearTimeout(timer);
    const input=event.target;
    if(input.value !== '' && Number.isInteger(Number(input.value)) && Number(input.value)>=0) change(input.dataset.mcKey,Number(input.value));
    else { pending=null; refresh(); }
  });
  window.addEventListener('pageshow',event=>{if(event.persisted) refresh();});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mischief-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mischief-reviews')) {
    customElements.define('mischief-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.track = this.querySelector('.mc-reviews__track');
        this.controls = this.querySelector('.mc-reviews__controls');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.controls) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const cards = Array.from(this.track.children);
        const isEditor = this.dataset.editor === 'true';
        const limit = Math.max(1, Number(this.dataset.count) || 6);
        if (!isEditor && this.dataset.randomize === 'true' && !this.dataset.shuffled) {
          for (let i = cards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [cards[i], cards[j]] = [cards[j], cards[i]];
          }
          cards.forEach(card => this.track.append(card));
          this.dataset.shuffled = 'true';
        }
        cards.forEach((card, index) => { card.hidden = !isEditor && index >= limit; });
        this.prev.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.mc-reviews__card');
          if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
